<template>
  <div class="import-tool">
    <Modal
      v-model="modalValue"
      title="导出"
      :footer-hide="true"
      :mask-closable="false"
      @on-cancel="modalValue=false"
      width="400"
      class="my-modal top import-tool-modal2"
    >
      <Form
        :label-width="60"
        ref="formValidate"
        :model="formData"
      >
        <FormItem label="手机号">
          <div class="mobile-item">
            <Input size="large" class="inp" disabled v-model="formData.mobile"></Input>
            <Button class="btn" @click="sendCode" v-if="countDownNum==60">发送验证码</Button>
            <Button disabled class="btn-num" v-else>{{ countDownNum }}s</Button>
          </div>
        </FormItem>

        <FormItem label="验证码" :rules="{required: true, message: '请输入'}" prop="exportVerifyCode">
          <Input size="large" v-model="formData.exportVerifyCode" maxlength="6" placeholder="请输入验证码"></Input>
        </FormItem>
      </Form>

      <div class="btn-box">
        <div class="cancel" @click="modalValue=false"><a>取消</a></div>
        <div class="confirm" @click="confirmForgetCode"><a>确认</a></div>
      </div>
    </Modal>
  </div>
</template>

<script>
import {common} from "@/api/mixins";
export default {
  mixins:[common],
  props:['exportUrl', 'requestParam'],
  data() {
    return {
      countDownNum:60,
      modalValue: false,
      formData:{
        mobile:'',
        exportVerifyCode:''
      },
      userInfo:JSON.parse(window.localStorage.getItem('userInfo')),
      timer:null
    };
  },
  methods:{
    open() {
      clearInterval(this.timer);
      this.countDownNum = 60;
      this.$refs.formValidate.resetFields();
      const mobile = this.userInfo.mobile;
      this.formData.mobile = mobile.replace(mobile.substring(3,7), "****");
      this.modalValue = true;
    },

    sendCode() {
      this.$http({
        url: '/buz/customerBase/export/sendCode',
        type: "POST",
      }).then(res=>{
        if(res.httpCode){
          this.timer = setInterval(() => {
            this.countDownNum = --this.countDownNum;
            if(this.countDownNum==0){
              this.countDownNum = 60;
              clearInterval(this.timer);
            }
          }, 1000);
        }
      })
    },

    confirmForgetCode() {
      this.$refs.formValidate.validate().then(isok=>{
        if(!isok){
          return
        }
        this.exportTable();
      })
    },

    exportTable() {
      let data = this.requestParam();
      data.exportVerifyCode = this.formData.exportVerifyCode;
      this.$http({
        url: this.exportUrl,
        type: "POST",
        forced: true,
        responseType: "blob",
        All: true,
        data,
      }).then(res=>{
        if(!res.headers["content-disposition"]){
          this.$Message.error('验证码输入错误');
        }else{
          this.$units.daochu(res);
          this.modalValue = false;
          this.formData.exportVerifyCode = '';
        }
      })
    }
  }
};
</script>

<style lang="scss" scoped>
.import-tool-modal2 /deep/ {
  .ivu-modal-header-inner{
    font-size: 14px;
    font-weight: bold;
    color: #3C464F;
  }
  .ivu-modal-close{
    top: 4px ;
    .ivu-icon-ios-close {
      font-size: 30px;
      color: #A8ADB7;
    }
  }
  .ivu-modal-header{
    padding: 0 20px;
    height: 40px;
    line-height: 40px;
  }  
  .ivu-modal-body {
    padding-top: 20px;
    padding-bottom: 25px;
  }
  .ivu-form-item-label {
    font-size: 12px;
    color: #515C6F;
  }
  .mobile-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .inp {
      width: 65%;
    }
    .btn {
      width: 30%;
      height: 30px;
      font-size: 12px;
      border: 1px solid #2b85e4;
      color: #2b85e4;
    }
    .btn-num {
      width: 30%;
      height: 30px;
      font-size: 12px;
    }
  }
  .btn-box {
    margin-top: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    .cancel {
      border: 1px solid #236DFF;
      border-radius: 2px;
      width: 100px;
      height: 30px;
      display: flex;
      align-items: center;
      justify-content: center;      
      a {
        display: block;
        color: #236DFF;
        font-size: 12px;
      }
    }
    .confirm {
      margin-left: 20px;
      background-color: #236DFF;
      border-radius: 2px;
      width: 100px;
      height: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
      a {
        display: block;
        color: #fff;
        font-size: 12px;
      }
    }
  }
}
</style>